//Stateler çekilip return edilecek

export const getWarehouses = (state) => {
  return state.warehouses
}

export const getWarehouseLoading = (state) => {
  return state.loading
}

export const getWarehouseStatus = (state) => {
  return state.warehouseStatus
}

export const getWarehouseProducts = (state) => {
  return state.warehouseProducts
}



// WEBPACK FOOTER //
// ./src/store/modules/Warehouse/Getters.js